<template>
    <div>
        <!-- 注：添加操作时，当左边没有树的值传入时，添加需要默认清空内容defaultEmpty，但包含树图或有内容传入时需要去掉该属性 -->
        <base-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="项目信息表"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="baseForm" defaultEmpty>
            <!-- 插槽部分 -->
            <template v-slot:default="{ruleForm}" class="info">
                        <!-- 项目名 -->
                        <el-form-item :label="columnInfo.name.label" prop="name">
                                <el-input v-model="ruleForm.name" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 项目code -->
                        <el-form-item :label="columnInfo.code.label" prop="code">
                                <el-input v-model="ruleForm.code" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 描述 -->
                        <el-form-item :label="columnInfo.description.label" prop="description">
                                <el-input v-model="ruleForm.description" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item :label="columnInfo.state.label" prop="state">
                                <enum-dict-select v-model="ruleForm.state" module-name="data" dict-code="state"></enum-dict-select>
                        </el-form-item>
            </template>
        </base-form-plus>
    </div>
</template>

<script>
    /**
     * 	项目信息表表单
     * 	@author PeterLee
     * 	@since 2025-11-09
     */
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        name: 'projectForm',
        // 计算操作
        computed: {
            ...mapState({
                // 校验规则
                rules: state => state.data.project.rules,
                // 表格数据
                tableData: state => state.data.project.tableData,
                // 表单信息
                formInfo: state => state.data.project.formInfo,
                // 下拉选项
                options: state => state.data.project.options,
                // 列信息
                columnInfo: state => state.data.project.columnInfo,
            })
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'data/project/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'data/project/submitAdd',
                submitEdit: 'data/project/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
